import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PcpcalendarComponent } from './pcpcalendar.component';



@NgModule({
    imports: [
        CommonModule,
        PcpcalendarComponent
    ],
    exports: [PcpcalendarComponent]
})
export class PcpcalendarModule { }
